import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useHistory } from "react-router-dom";
import { auth } from "../../Authentication/firebase/firebase";
import API_Root from "../../Constants/API_Root";
import { doSignOut } from "../../Authentication/firebase/auth";
import { toggleToast } from "../../Actions/ToggleToast";
import { useDispatch } from "react-redux";
import { authFetch } from "../../Authentication/authService";

const SIDEBAR_WIDTH = 250;

function TrainingPage() {
  const dispatch = useDispatch();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);
  const [hoveredItem, setHoveredItem] = useState(null);

  const history = useHistory();

  const [userEmail, setUserEmail] = useState("");

  const [trainingData, setTrainingData] = useState([]);
  const [availableTraining, setAvailabletraining] = useState([]);
  const [achivement, setAchivement] = useState([]);

  // TRAINING VIEWER
  const [showTrainingViewer, setShowTrainingViewer] = useState(false);
  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);
  const [moduleFiles, setModuleFiles] = useState([]);

  const [loadingModules, setLoadingModules] = useState(false);
  const [loadingFiles, setLoadingFiles] = useState(false);

  const [downloading, setDownloading] = useState("");
  const [playingVideo, setPlayingVideo] = useState(null);

  // TRACKERS
  const [watchedVideos, setWatchedVideos] = useState([]);
  const [downloadedFiles, setDownloadedFiles] = useState([]);
  const [allModuleFiles, setAllModuleFiles] = useState({});
  const [overallProgressValue, setOverallProgressValue] = useState(0);

  const [course1Progress, setCourse1Progress] = useState(0);
  const [course2Progress, setCourse2Progress] = useState(0);
  const [selectedCourseId, setSelectedCourseId] = useState(1);
  const [overallProgress, setOverallProgress] = useState(0);
  const [filenamesToShow, setFilenamesToShow] = useState("");

  // ==========================
  // AUTH
  // ==========================
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserEmail(user.email);

        userTraining(user.email);
        userAchivement(user.email);
        getAvailableTraining();

        fetchUserProgress(1);
        fetchUserProgress(2);
      } else {
        setUserEmail("");
      }
    });

    return () => unsubscribe();
  }, []);

  // ==========================
  // RESPONSIVE
  // ==========================
  useEffect(() => {
    const resize = () => setIsDesktop(window.innerWidth >= 768);

    window.addEventListener("resize", resize);

    return () => window.removeEventListener("resize", resize);
  }, []);

  // ==========================
  // FETCH OVERALL PROGRESS
  // ==========================
  useEffect(() => {
    if (userEmail) {
      fetchOverallProgress();
    }
  }, [userEmail]);

  // ==========================
  // USER TRAININGS
  // ==========================
  const userTraining = (username) => {
    authFetch(API_Root + "users/get-user-trainings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username }),
    })
      .then((response) => response.json())
      .then((data) => {
        setTrainingData(data.trainings || []);
      })
      .catch((error) => console.error(error));
  };

  // ==========================
  // ACHIEVEMENTS
  // ==========================
  const userAchivement = (username) => {
    authFetch(API_Root + "users/get-achievements-by-user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username }),
    })
      .then((response) => response.json())
      .then((data) => {
        setAchivement(data.completed_trainings || []);
      })
      .catch((error) => console.error(error));
  };

  // ==========================
  // AVAILABLE TRAININGS
  // ==========================
  const getAvailableTraining = () => {
    authFetch(API_Root + "users/get-available-trainings", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setAvailabletraining(data.data || []);
      })
      .catch((error) => console.error(error));
  };

  // ==========================
  // FETCH MODULES
  // ==========================
  const fetchModules = async (courseId) => {
    try {
      setLoadingModules(true);

      const response = await authFetch(API_Root + "files/fetch-modules", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          course_id: courseId,
        }),
      });

      const data = await response.json();

      setModules(data.modules || data.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingModules(false);
    }
  };

  // ==========================
  // FETCH FILES
  // ==========================
  const fetchModuleFiles = async (moduleName) => {
    try {
      setLoadingFiles(true);

      setSelectedModule(moduleName);

      const response = await authFetch(API_Root + "files/fetch-files", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module_name: moduleName,
          course_id: selectedCourseId,
        }),
      });

      const data = await response.json();

      setModuleFiles(data.files || []);
      // SAVE MODULE FILES GLOBALLY
      setAllModuleFiles((prev) => ({
        ...prev,
        [moduleName]: data.files || [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingFiles(false);
    }
  };

  // ==========================
  // UPDATE PROGRESS
  // ==========================
  const updateProgress = async (filename) => {
    try {
      await authFetch(API_Root + "users/update-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: userEmail,
          training_id: selectedCourseId,
          filename,
        }),
      });

      setWatchedVideos((prev) => {
        if (prev.includes(filename)) return prev;

        return [...prev, filename];
      });

      // REFRESH BACKEND PROGRESS
      fetchOverallProgress();
    } catch (error) {
      console.error(error);
    }
  };

  // ==========================
  // DOWNLOAD PDF
  // ==========================
  const downloadPDF = async (filename) => {
    try {
      setDownloading(filename);

      const response = await authFetch(API_Root + "files/download-pdf", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          filename,
          email: userEmail,
          training_id: selectedCourseId,
        }),
      });

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");

      a.href = url;
      a.download = filename;

      document.body.appendChild(a);

      a.click();

      a.remove();

      window.URL.revokeObjectURL(url);

      // MARK AS DOWNLOADED
      setDownloadedFiles((prev) => [...new Set([...prev, filename])]);

      // REFRESH BACKEND PROGRESS
      fetchOverallProgress();
    } catch (error) {
      console.error(error);
    } finally {
      setDownloading("");
    }
  };

  // ==========================
  // MODULE PROGRESS
  // ==========================
  const getModuleProgress = (moduleName) => {
    // FIND CURRENT MODULE FILES
    let files = [];

    // If selected module matches
    if (selectedModule === moduleName) {
      files = moduleFiles || [];
    }

    // If no files loaded yet
    if (!files.length) return 0;

    let totalPoints = 0;
    let completedPoints = 0;

    files.forEach((file) => {
      const filename = typeof file === "string" ? file : file.filename;

      const isVideo =
        filename?.toLowerCase().endsWith(".mp4") ||
        filename?.toLowerCase().endsWith(".mov");

      const isPDF = filename?.toLowerCase().endsWith(".pdf");

      // VIDEO = 50%
      if (isVideo) {
        totalPoints += 50;

        if (watchedVideos.includes(filename)) {
          completedPoints += 50;
        }
      }

      // PDF = 50%
      if (isPDF) {
        totalPoints += 50;

        if (downloadedFiles.includes(filename)) {
          completedPoints += 50;
        }
      }
    });

    return totalPoints ? Math.round((completedPoints / totalPoints) * 100) : 0;
  };

  // ==========================
  // OVERALL PROGRESS
  // ==========================
  const fetchOverallProgress = async () => {
    try {
      const response = await authFetch(API_Root + "users/get-user-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: userEmail,
          course_id: selectedCourseId,
        }),
      });

      const data = await response.json();

      // API RETURNS:
      // {
      //   user_progress: "32"
      // }

      const progress = Number(data?.user_progress || 0);

      setOverallProgressValue(progress);
    } catch (error) {
      console.error(error);
    }
  };

  // ==========================
  // STYLES
  // ==========================
  const sidebarStyle = {
    width: SIDEBAR_WIDTH,
    minHeight: "100vh",
    backgroundColor: "#f8f9fa",
    borderRight: "1px solid #e0e0e0",
    padding: "20px",
    position: isDesktop ? "relative" : "fixed",
    top: 0,
    left: isDesktop ? 0 : sidebarOpen ? 0 : -SIDEBAR_WIDTH,
    transition: "left 0.3s ease",
    zIndex: 1000,
  };

  const overlayStyle = {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.3)",
    display: !isDesktop && sidebarOpen ? "block" : "none",
    zIndex: 999,
  };

  const navItemStyle = {
    padding: "10px 15px",
    borderRadius: "6px",
    cursor: "pointer",
    marginBottom: "5px",
  };

  const activeNavItemStyle = {
    ...navItemStyle,
    backgroundColor: "#000",
    color: "#fff",
  };

  const handleLogout = () => {
    doSignOut()
      .then(() => {
        localStorage.removeItem("isLoggedIn");
        history.push("/");
      })
      .catch(() => {
        dispatch(
          toggleToast({
            show: true,
            type: "error",
            message: "Logout failed",
          })
        );
      });
  };

  const getHoverStyle = (item) => ({
    ...navItemStyle,
    backgroundColor: hoveredItem === item ? "#e6e6e6" : "transparent",
  });

  // ==========================
  // NAVIGATION
  // ==========================
  const AccountPage = () => history.push("/profile");

  const ShopPage = () => history.push("/shops");

  const ProductPage = () => history.push("/myproduct");

  const SuportPage = () => history.push("/support");

  const ActivityPage = () => history.push("/activity");

  const fetchUserProgress = async (courseId) => {
    try {
      const response = await authFetch(API_Root + "users/get-user-progress", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: userEmail,
          course_id: courseId,
        }),
      });

      const data = await response.json();

      const progress = data?.user_progress || 0;

      setOverallProgress(progress);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div style={overlayStyle} onClick={() => setSidebarOpen(false)} />

        <div className="d-flex">
          {/* SIDEBAR */}
          <div style={sidebarStyle}>
            <h5 className="fw-bold">E&S Solutions</h5>

            <div
              style={getHoverStyle("My Products")}
              onMouseEnter={() => setHoveredItem("My Products")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={ProductPage}
            >
              My Products
            </div>

            <div
              style={getHoverStyle("Shop")}
              onMouseEnter={() => setHoveredItem("Shop")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={ShopPage}
            >
              Shop / Marketplace
            </div>

            <div style={activeNavItemStyle}>Training Centre</div>

            <div
              style={getHoverStyle("Support")}
              onMouseEnter={() => setHoveredItem("Support")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={SuportPage}
            >
              Support & Help
            </div>

            <div
              style={getHoverStyle("Account")}
              onMouseEnter={() => setHoveredItem("Account")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={AccountPage}
            >
              Account Settings
            </div>

            <div
              style={getHoverStyle("Activity")}
              onMouseEnter={() => setHoveredItem("Activity")}
              onMouseLeave={() => setHoveredItem(null)}
              onClick={ActivityPage}
            >
              Activity Log
            </div>
          </div>

          {/* MAIN */}
          <div style={{ width: "100%" }}>
            {/* TOPBAR */}
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <h4 className="fw-bold m-0">Training Centre</h4>

              <div>
                <button
                  className="me-2"
                  onClick={handleLogout}
                  style={{
                    border: "1px solid black",
                    backgroundColor: "transparent",
                    cursor: "pointer",
                    padding: "5px",
                    transition: "all 0.3s ease",
                    fontSize: "small",
                  }}
                >
                  Logout
                </button>

                <i className="bi bi-bell me-3"></i>
              </div>
            </div>

            {/* CONTENT */}
            <div className="p-4">
              {availableTraining?.length > 0 && (
                <div>
                  <h4 className="fw-bold mb-3">Available Trainings</h4>

                  <div className="row g-4">
                    {availableTraining.map((item, index) => (
                      <div className="col-12 col-md-6 col-lg-4" key={index}>
                        <div className="card h-100 shadow-sm border-0 rounded-4 overflow-hidden">
                          <img
                            src={item.training_icon}
                            alt="training"
                            style={{
                              height: "220px",
                              objectFit: "cover",
                            }}
                          />

                          <div className="card-body">
                            <h5 className="fw-bold">{item.training_name}</h5>

                            <p className="text-muted">
                              {item.training_description}
                            </p>

                            <button
                              className="btn w-100 text-white fw-semibold"
                              style={{
                                background: "#3E826D",
                              }}
                              onClick={() => {
                                setSelectedCourseId(item.training_id);
                                setShowTrainingViewer(true);
                                fetchModules(item.training_id);
                                setFilenamesToShow(item.training_name);
                              }}
                            >
                              Start Training
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* FULLSCREEN VIEWER */}
      {showTrainingViewer && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "#f8fafc",
            zIndex: 9999,
          }}
        >
          {/* HEADER */}
          <div
            className="d-flex justify-content-between align-items-center px-4"
            style={{
              height: "70px",
              background: "#fff",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div>
              <h4 className="fw-bold mb-0">{filenamesToShow}</h4>

              {/* <small className="text-muted">
                Interactive Learning Workspace
              </small> */}
            </div>

            <button
              className="btn btn-dark"
              onClick={() => {
                setShowTrainingViewer(false);

                setSelectedModule(null);

                setModuleFiles([]);

                setPlayingVideo(null);
              }}
            >
              Close
            </button>
          </div>

          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 70px)",
            }}
          >
            {/* LEFT SIDEBAR */}
            <div
              style={{
                width: "340px",
                background: "#fff",
                borderRight: "1px solid #e5e7eb",
                overflowY: "auto",
                padding: "20px",
              }}
            >
              {/* OVERALL */}
              <div className="mb-4">
                <div className="d-flex justify-content-between mb-2">
                  <span className="fw-bold">Overall Progress</span>

                  <span className="fw-semibold">{overallProgress}%</span>
                </div>

                <div
                  className="progress"
                  style={{
                    height: "10px",
                    borderRadius: "20px",
                  }}
                >
                  <div
                    className="progress-bar"
                    style={{
                      width: `${overallProgress}%`,
                      background: "#3E826D",
                    }}
                  ></div>
                </div>
              </div>

              <h5 className="fw-bold mb-4">Modules</h5>

              {loadingModules ? (
                <div className="text-center mt-5">
                  <div className="spinner-border"></div>
                </div>
              ) : (
                modules.map((module, index) => {
                  const moduleName =
                    typeof module === "string" ? module : module.module_name;

                  const progress = getModuleProgress(moduleName);

                  return (
                    <div
                      key={index}
                      onClick={() => fetchModuleFiles(moduleName)}
                      style={{
                        padding: "16px",
                        borderRadius: "16px",
                        marginBottom: "14px",
                        cursor: "pointer",
                        border:
                          selectedModule === moduleName
                            ? "2px solid #3E826D"
                            : "1px solid #e5e7eb",
                        background:
                          selectedModule === moduleName ? "#ecfdf5" : "#fff",
                        transition: "0.2s",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                          <div className="fw-semibold">{moduleName}</div>

                          <small className="text-muted">Training Module</small>
                        </div>

                        <div
                          className="fw-bold"
                          style={{
                            color: progress === 100 ? "#198754" : "#3E826D",
                          }}
                        >
                          {progress}%
                        </div>
                      </div>

                      <div
                        className="progress"
                        style={{
                          height: "7px",
                          borderRadius: "20px",
                        }}
                      >
                        <div
                          className="progress-bar"
                          style={{
                            width: `${progress}%`,
                            background:
                              progress === 100 ? "#198754" : "#3E826D",
                          }}
                        ></div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>

            {/* RIGHT CONTENT */}
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "30px",
              }}
            >
              {!selectedModule ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <div className="text-center">
                    <i
                      className="bi bi-play-circle"
                      style={{
                        fontSize: "80px",
                        color: "#3E826D",
                      }}
                    ></i>

                    <h3 className="mt-4 fw-bold">Select a Module</h3>

                    <p className="text-muted">
                      Choose a module to begin training.
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  <div className="mb-4">
                    <h2 className="fw-bold">{selectedModule}</h2>
                  </div>

                  {loadingFiles ? (
                    <div className="text-center mt-5">
                      <div className="spinner-border"></div>
                    </div>
                  ) : (
                    <div className="row g-4">
                      {moduleFiles.map((file, idx) => {
                        const filename = file.filename;

                        const isVideo =
                          filename?.endsWith(".mp4") ||
                          filename?.endsWith(".mov");

                        const isPDF = filename?.endsWith(".pdf");

                        return (
                          <div className="col-12" key={idx}>
                            <div className="bg-white rounded-4 shadow-sm p-4">
                              {/* VIDEO */}
                              {isVideo && (
                                <>
                                  <video
                                    width="100%"
                                    height="500"
                                    controls
                                    style={{
                                      borderRadius: "18px",
                                      background: "#000",
                                    }}
                                    onLoadedData={() => {
                                      setPlayingVideo(filename);

                                      updateProgress(filename);
                                    }}
                                  >
                                    <source
                                      src={file.video_link}
                                      type="video/mp4"
                                    />
                                  </video>

                                  <div className="mt-3 d-flex justify-content-between">
                                    <div>
                                      <h5 className="fw-bold">{filename}</h5>
                                      {/* 
                                      <small className="text-muted">
                                        Training Video
                                      </small> */}
                                    </div>

                                    {watchedVideos.includes(filename) && (
                                      <span className="badge bg-success h-100">
                                        Watched
                                      </span>
                                    )}
                                  </div>
                                </>
                              )}

                              {/* PDF */}
                              {isPDF && (
                                <div className="d-flex justify-content-between align-items-center">
                                  <div className="d-flex align-items-center">
                                    <i className="bi bi-file-earmark-pdf-fill text-danger fs-1 me-3"></i>

                                    <div>
                                      <h5 className="fw-bold mb-1">
                                        {filename}
                                      </h5>

                                      {/* <small className="text-muted">
                                        Training PDF
                                      </small> */}
                                    </div>
                                  </div>

                                  <div className="d-flex align-items-center gap-3">
                                    {downloadedFiles.includes(filename) && (
                                      <span className="badge bg-success">
                                        Downloaded
                                      </span>
                                    )}

                                    <button
                                      className="btn text-white"
                                      style={{
                                        background: "#3E826D",
                                      }}
                                      onClick={() => downloadPDF(filename)}
                                      disabled={downloading === filename}
                                    >
                                      {downloading === filename ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm me-2"></span>
                                          Downloading
                                        </>
                                      ) : (
                                        <>
                                          <i className="bi bi-download me-2"></i>
                                          Download
                                        </>
                                      )}
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TrainingPage;
